export default "__VITE_ASSET__DQqvc_dC__"